import React, { useEffect, useRef, useState } from "react";
import "./DosaChutneyContact.scss"
import border from "../../assets/images/border.png"
import InputComponent from "../../components/InputComponents/InputComponent";
import TextAreaComponent from "../../components/InputComponents/TextAreaComponent";
import { contactEnquiry } from "../../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import { useSelector } from "react-redux";
import { sortByOrderAscending } from "../../helper/helper";

const DosaChutneyContact = () => {
    const company = useSelector((state) => state.companyData.company)
    const containerRef = useRef(null);
    const contentRef = useRef(null);
    const [fullName, setFullName] = useState("")
    const [email, setEmail] = useState("")
    const [message, setMessage] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [errors, setErrors] = useState({
        fullName: "",
        email: "",
        message: "",
        phoneNumber: "",
    })
    const [loading, setLoading] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "contact")
    const Components = page?.Components || []
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    // useEffect(() => {
    //     const container = containerRef.current;
    //     const content = contentRef.current;

    //     if (!container || !content) return;

    //     let scrollLeft = 0;
    //     let animationFrame;

    //     const clone = content.cloneNode(true);
    //     container.appendChild(clone);

    //     const animate = () => {
    //         scrollLeft += 0.5;
    //         if (scrollLeft >= content.scrollWidth) {
    //             scrollLeft = 0;// Reset seamlessly
    //         }
    //         container.scrollLeft = scrollLeft;
    //         animationFrame = requestAnimationFrame(animate);
    //     };

    //     animationFrame = requestAnimationFrame(animate);

    //     return () => cancelAnimationFrame(animationFrame);
    // }, []);
    const getImagesCarousel = (data) => {
        return (
            <div className="DosaChutneyContact-ImageCarousel" ref={containerRef}>
                <div className="DosaChutneyContact-Cont" ref={contentRef}>
                    {data?.map((data, index) => (
                        <img key={index} src={data?.src} alt={`img-${index}`} className="DosaChutneyContact-Cont-image" />

                    ))}
                </div>
            </div>
        )
    }
    const handleChange = (name) => {
        setErrors({
            ...errors,
            [name]: "",
        });
    };
    const validateEmail = () => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const validateForm = () => {
        let valid = true;
        const nameRegex = /^[A-Za-z]+([ '-][A-Za-z]+)*$/;
        let newErrors = {
            fullName: "",
            email: "",
            message: "",
            phoneNumber: "",
        }
        const trimmedName = fullName.trim();
        const trimmedEmail = email.trim();
        const trimmedPhone = phoneNumber.trim();
        if (trimmedName === "") {
            newErrors.fullName = "*Required";
            valid = false;
        } else if (trimmedName.length < 2 || !nameRegex.test(trimmedName)) {
            newErrors.fullName = "Please enter a valid name";
            valid = false;
        }


        if (trimmedEmail === "") {
            newErrors.email = "*Required";
            valid = false;
        } else if (!validateEmail(trimmedEmail)) {
            newErrors.email = "*Invalid email format";
            valid = false;
        }


        if (trimmedPhone === "") {
            newErrors.phoneNumber = "*Required";
            valid = false;
        }

        if (message.trim() === "") {
            newErrors.message = "*Required";
            valid = false;
        }
        setErrors(newErrors);
        return valid;
    };
    const handleContact = async () => {
        const data = {
            "WebsiteID": company?.ID || "",
            "Name": fullName,
            "Email": email,
            "PhoneNo": phoneNumber,
            "Message": message,
            "Subject": "",
            "OrderID": "",
        }
        if (validateForm() && !loading) {
            setLoading(true)
            let res = await contactEnquiry(data)
            if (res) {
                setEmail("")
                setFullName("")
                setMessage("")
                setPhoneNumber("")
                setLoading(false)
                setShowSuccess(true)
                setTimeout(() => {
                    document.querySelector('.succes-alert').classList.add('fade-out');
                    setTimeout(() => {
                        setShowSuccess(false)
                    }, 1000);
                }, 2000);
            } else {
                setLoading(false)
            }
        }
    }
    const getForm = () => {
        return (
            <div className="DosaChutneyContact-Form">
                <InputComponent
                    label={"Name"}
                    placeholder={""}
                    value={fullName}
                    onChange={(e) => {
                        setFullName(e.target.value)
                        handleChange("fullName")
                    }}
                    error={errors.fullName !== ""}
                    errorText={errors.fullName}
                    required />
                <InputComponent
                    label={"Email"}
                    placeholder={""}
                    onChange={(e) => {
                        setEmail(e.target.value)
                        handleChange("email")

                    }}
                    value={email}
                    error={errors.email !== ""}
                    errorText={errors.email}
                    required />
                <InputComponent
                    label={"Phone"}
                    placeholder={""}
                    onChange={(e) => {
                        setPhoneNumber(e.target.value)
                        handleChange("phoneNumber")

                    }}
                    value={phoneNumber}
                    error={errors.phoneNumber !== ""}
                    errorText={errors.phoneNumber}
                    type="number"
                    required />

                <TextAreaComponent
                    label={"Message"}
                    placeholder={""}
                    onChange={(e) => {
                        setMessage(e.target.value)
                        handleChange("message")

                    }}
                    value={message}
                    error={errors.message !== ""}
                    errorText={errors.message}
                    required />
                {showSuccess && < div className="succes-alert">
                    ✔ Thanks for contacting us! We’ve received your message and will be in touch soon.
                </div>}
                <div className="DosaChutneyContact-Form-button"
                    onClick={() => {
                        handleContact()
                    }}>
                    {loading && <div className="DosaChutneyContact-Form-button-loader-btn" />}  Send Message
                </div>
            </div>)
    }
    const getHeroComponent = (component) => {
        switch (component.ID) {
            case "DosaChutneyContact-Hero-header":
                return <div className="DosaChutneyContact-Hero-header">
                    {component?.Props?.text}
                </div>
            case "DosaChutneyContact-Hero-subheader":
                return <div className="DosaChutneyContact-Hero-subheader">
                    {component?.Props?.text}
                </div>
            default:
                return <div />
        }

    }
    const getHeroContent = (components, heroBackground) => {
        return (
            <div className="DosaChutneyContact-Hero"
                style={{
                    backgroundImage: `linear-gradient(135deg, rgba(32, 70, 7, 0.59), rgba(19, 44, 2, 0.7)), url(${heroBackground})`
                }}>
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getHeroComponent(component)
                    )
                })}
            </div>
        )
    }
    const getFormContentComponent = (component) => {
        switch (component.ID) {
            case "DosaChutneyContact-Container-header-subtext":
                return <div className="DosaChutneyContact-Container-header-subtext">
                    {component?.Props?.text}
                </div>
            case "DosaChutneyContact-Container-header-text":
                return <div className="DosaChutneyContact-Container-header-text">
                    {component?.Props?.text}
                </div>
            case "DosaChutneyContact-Container-border":
                return <img alt="" src={border}
                    className="DosaChutneyContact-Container-header-border" />
            case "DosaChutneyContact-Container-header-content":
                return <div className="DosaChutneyContact-Container-header-content">
                    {component?.Props?.text}
                </div>
            case "DosaChutneyContact-Container-form":
                return getForm()
            default:
                return <div />
        }

    }
    const getFormContent = (components) => {
        return (
            <div className="DosaChutneyContact-Container">
                <div className="DosaChutneyContact-Container-header">
                    {sortByOrderAscending(components).map((component, key) => {
                        return (
                            getFormContentComponent(component)
                        )
                    })}
                </div>
            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "DosaChutneyContact-Hero":
                return getHeroContent(component.Components, component?.Props?.bgSrc)
            case "DosaChutneyContact-Container":
                return getFormContent(component?.Components[0]?.Components)
            case "DosaChutneyContact-Images":
                return getImagesCarousel(component.Data)
            default:
                return <div />
        }

    }
    return (
        <div className="DosaChutneyContact">
            {sortByOrderAscending(Components).map((component, key) => {
                return (<div key={key}>
                    {getComponents(component)}
                </div>)
            })}
        </div>
    )
}
export default DosaChutneyContact